import type { FC } from "react";
import React from "react";
import classNames from "classnames";
import styles from "./MatchEventsTimeline.module.scss";

const MatchEventsTimeline: FC<{ timeline: string; inner?: boolean }> = ({
  timeline,
  inner = false,
}) => {
  return (
    <p
      className={classNames(
        "title-8-bold",
        styles.matchEventsItemTimeline,
        inner
          ? styles.matchEventsItemTimelineInner
          : styles.matchEventsItemTimelineOuter,
      )}
    >
      {timeline}
    </p>
  );
};

export { MatchEventsTimeline };
